import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const SURFACE_HEIGHT_MIN = 320;
const SURFACE_HEIGHT_MAX = '56vh';

export const githubIssueEditorStyles = StyleSheet.create({
	frame: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
		overflow: 'hidden',
		transition: 'border-color 0.15s, box-shadow 0.15s',
		':focus-within': {
			borderColor: THEME.colors.primary.main,
			boxShadow: `0 0 0 3px ${THEME.colors.primary.light}`,
		},
	},
	frameDisabled: {
		opacity: 0.7,
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: SPACE[8],
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		backgroundColor: THEME.colors.background.main,
	},
	toolbarActions: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: SPACE[4],
		minWidth: 0,
	},
	toolbarFormatActions: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: SPACE[4],
	},
	insertButton: {
		gap: SPACE[4],
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	toolbarActionsHidden: {
		display: 'none',
	},
	toolbarDivider: {
		width: 1,
		height: SPACE[16],
		margin: `0 ${SPACE[4]}px`,
		backgroundColor: THEME.colors.border.main,
	},
	toolbarButton: {
		minWidth: SPACE[28],
		height: SPACE[28],
		padding: `0 ${SPACE[8]}px`,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		':hover:not(:disabled)': {
			color: THEME.colors.text.main,
			backgroundColor: THEME.colors.hover.light,
		},
	},
	toolbarButtonActive: {
		color: THEME.colors.primary.main,
		backgroundColor: THEME.colors.primary.light,
	},
	labelBold: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	labelItalic: {
		fontStyle: 'italic',
		fontFamily: 'Georgia, serif',
	},
	labelStrike: {
		textDecoration: 'line-through',
	},
	labelMono: {
		fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
	},
	modeToggle: {
		flex: 'none',
	},
	surface: {
		position: 'relative',
		minHeight: SURFACE_HEIGHT_MIN,
		maxHeight: SURFACE_HEIGHT_MAX,
		overflowY: 'auto',
		cursor: 'text',
	},
	hidden: {
		display: 'none',
	},
	source: {
		minHeight: SURFACE_HEIGHT_MIN,
		maxHeight: SURFACE_HEIGHT_MAX,
		height: SURFACE_HEIGHT_MAX,
		padding: `${SPACE[16]}px ${SPACE[20]}px`,
		border: 'none',
		borderRadius: 0,
		fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.6,
		resize: 'none',
		':focus': {
			outline: 'none',
			boxShadow: 'none',
		},
	},
	imageMenu: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[4],
		padding: SPACE[4],
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
		boxShadow: `0 ${SPACE[4]}px ${SPACE[16]}px ${THEME.colors.border.main}`,
		zIndex: 2,
	},
	imageMenuInput: {
		width: 280,
		height: SPACE[28],
		fontSize: THEME.typography.fontSizes.xs,
	},
	imageMenuDelete: {
		color: THEME.colors.danger.main,
		':hover:not(:disabled)': {
			color: THEME.colors.danger.main,
			backgroundColor: THEME.colors.danger.light,
		},
	},
	dropIndicator: {
		position: 'absolute',
		left: SPACE[16],
		right: SPACE[16],
		height: 2,
		marginTop: -1,
		borderRadius: THEME.common.borderRadiusSm,
		backgroundColor: THEME.colors.primary.main,
		pointerEvents: 'none',
	},
});
